import { COMPONENT_VALUE_TYPES as types, COMPONENT_COLOR_THEMES } from 'shared/constants';

const propsSchema = [
  {
    key: 'notes',
    label: 'Notes',
    type: types.ARRAY,
    children: [
      {
        key: 'note',
        label: 'Note',
        type: types.TEXT
      }
    ]
  },
  {
    key: 'additional_space',
    label: 'Additional Space (Keep this checked if sticky sub nav is used on the page)',
    type: types.BOOLEAN
  },
  {
    key: 'color_theme',
    label: 'Color Theme',
    type: types.ENUM,
    options: COMPONENT_COLOR_THEMES
  }
];

const defaultProps = {
  notes: [
     { note: 'Interior Space – Claims based on 2014 Mercedes Benz S Class. Source: emercedesbenz.com' },
     { note: 'Lidar – Production vehicle specifications may differ.' },
     { note: 'Camera Mirrors – Camera and rear view mirrors are both standard.' },
     { note: 'Range – Production vehicle specifications may differ.' },
     { note: 'Woman silhouette image by Nicola. Modified from original. Licensed under Creative Commons License https://creativecommons.org/licenses/by/2.0/' }
  ],
  additional_space: true,
  color_theme: 'DARK'
};

export default {
  title: 'Footnote',
  id: 'Footnote',
  propsSchema,
  defaultProps
};
